import { ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { NX_MODAL_DATA, NxModalRef } from '@aposin/ng-aquila/modal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store, Select } from '@ngxs/store';
import { SEARCH_ENDORSEMENT_MAKE_MODEL, SEARCH_MAKE_MODEL } from "@store/sat-motor/sat-motor.action";
import { Subject, debounceTime, of, takeUntil } from "rxjs";
import { SatMotorState } from "@store/sat-motor/sat-motor.state";

@Component({
  selector: 'app-make-model',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './make-model.component.html',
  styleUrl: './make-model.component.scss',
})
export class MakeModelComponent implements OnInit {
  @ViewChild('tableHeader', { static: false }) tableHeader: ElementRef<HTMLTableHeaderCellElement>;
  @Select(SatMotorState.motorActionType) actionType$;

  isEndorsement: boolean = false;

  searchModelForm: FormGroup;

  searchMakeModelAutoList: any = [];
  searchMakeModelList: any = [];

  curpage: number = 1;
  perPage: number = 10;
  itemsPerPageSelections = [10, 20, 50, 100];
  
  searchPerformed: boolean = false;

  count: number = 0;
  showPagination: boolean = false;
  pageFilterForm: FormGroup;
  unsubscribe$ = new Subject();

  constructor(
    @Inject(NX_MODAL_DATA) public data: any,
    private dialogRef: NxModalRef<any>,
    private fb: FormBuilder,
    private store: Store,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {

    this.searchPerformed = false;

    this.actionType$.subscribe((state) => {
      if (state) {
        this.isEndorsement = state.isEndorsement;
      }
    });
    
    this.searchModelForm = this.fb.group({
      searchBy: [''],
    });
    
    this.pageFilterForm = this.fb.group({
      perPage: [this.perPage]
    });

    // this.searchBy.valueChanges.subscribe((value) => {
    //   if (value && value.length > 2) {
    //     this.store.dispatch(new SEARCH_MAKE_MODEL({ type: value, classCode: this.data.vehicleClass, yearMnftr: this.data.yearMnftr })).subscribe((state) => {
    //       this.searchMakeModelAutoList = state.SatMotorState.data.step3.coverage.searchMakeModelList;
    //       this.setAutocompleteWidth();
    //     });   
    //   } else {
    //     this.searchMakeModelAutoList = [];
    //     this.searchMakeModelList = [];
    //   }
    // });
  }

  // @ViewChild('searchInput', { static: false }) searchInput!: ElementRef;
  // setAutocompleteWidth() {
  //   const inputWidth = this.searchInput.nativeElement.offsetWidth;
  //   const formFieldWidth = inputWidth + 64;

  //   const overlayPane = document.querySelector('.nx-autocomplete-panel');
  //   if (overlayPane) {
  //     overlayPane.setAttribute('style', `min-width: 0px !important; max-width: ${formFieldWidth}px !important;`);
  //   }
  // }

  onMakeModelSelectedValue(item) {
    return (item.piamMakeModelDesc + " " + item.variantFullDesc).toUpperCase();
  }

  onMakeModelSelected(event) {
    this.select(event.option.value);
  }

  onSearchClicked() {
    this.searchMakeModelList = [];
    this.showPagination = false;
    this.searchModelForm.controls["searchBy"].setValidators([Validators.required]);
    this.searchModelForm.controls["searchBy"].updateValueAndValidity();
    
    let value = this.searchModelForm.getRawValue()["searchBy"];
    
    if (!this.searchModelForm.controls["searchBy"].valid) {
      this.searchModelForm.controls["searchBy"].markAllAsTouched();
      return;
    }

    if (this.isEndorsement) {
      this.store.dispatch(new SEARCH_ENDORSEMENT_MAKE_MODEL({ type: value, classCode: this.data.vehicleClass, yearMnftr: this.data.yearMnftr })).subscribe((state) => {
        this.searchMakeModelList = state.SatMotorState.data.step2.endorsementDetails.searchMakeModelList;
        this.searchPerformed = true;
        if (this.searchMakeModelList && this.searchMakeModelList.length > 10) {
          this.showPagination = true;
        }
        this.setItemPerPage();
        this.searchMakeModelAutoList = [];
      });
    } else {
      this.store.dispatch(new SEARCH_MAKE_MODEL({ type: value, classCode: this.data.vehicleClass, yearMnftr: this.data.yearMnftr })).subscribe((state) => {
        this.searchMakeModelList = state.SatMotorState.data.step3.coverage.searchMakeModelList;
        this.searchPerformed = true;
        if (this.searchMakeModelList && this.searchMakeModelList.length > 10) {
          this.showPagination = true;
        }
        this.setItemPerPage();
        this.searchMakeModelAutoList = [];
      });    
    }    
  }

  removeValidation() {
    this.searchModelForm.get('searchBy')?.clearValidators();
    this.searchModelForm.get('searchBy')?.updateValueAndValidity();
  }

  reset() {
    this.searchModelForm.controls["searchBy"].setValue("");
    this.searchModelForm.get('searchBy')?.clearValidators();
    this.searchModelForm.get('searchBy')?.updateValueAndValidity();
    this.searchMakeModelList = [];
    this.perPage = 10;
    this.curpage = 1;
    this.searchPerformed = false;
  }

  select(item: any) {
    this.dialogRef.close({ item });
  }

  prevPage() {
    this.curpage--;
    this.scrollIntoView();
  }

  nextPage() {
    this.curpage++;
    this.scrollIntoView();
  }

  goToPage(n: number) {
    this.curpage = n;
    this.scrollIntoView();
  }

  scrollIntoView() {
    this.tableHeader.nativeElement.scrollIntoView({ behavior: "smooth" });
  }

  setItemPerPage() {
    this.pageFilterForm.get('perPage').valueChanges.pipe(
      debounceTime(250),
      takeUntil(this.unsubscribe$)
    ).subscribe((value) => {
      this.perPage = value;
      this.curpage = 1;
      this.scrollIntoView();
    });
  }

  get paginatedResults() {
    if (this.searchMakeModelList) {
      const startIndex = (this.curpage - 1) * this.perPage;
      return this.searchMakeModelList.slice(startIndex, startIndex + this.perPage);
    }
    return [];
  }

  getResultLength() {
    if (this.searchMakeModelList) {
      return this.searchMakeModelList.length;
    }
    return 0;
  }

  get searchBy() {
    return this.searchModelForm.controls["searchBy"];
  }

  clearSearch(): void {
    this.searchModelForm.get('searchBy')?.reset();
    this.reset();
  }

  toggle_overflow = false;
  screenWidth!: number;
  ngAfterViewInit() {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth < 992) {
      this.toggle_overflow = true;
    } else {
      this.toggle_overflow = false;
    }
    this.cdr.detectChanges();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth < 992) {
      this.toggle_overflow = true;
    } else {
      this.toggle_overflow = false;
    }
    this.cdr.detectChanges();
  }
}
